export default __webpack_public_path__ + "static/media/portatambor.d196c3ab.png";